export default __webpack_public_path__ + "static/media/regulatory--road-closed--g1.9e903e6d.png";